/* eslint-disable camelcase */
import React from 'react'

import './index.css'
import Flex from 'components/Flex'
import compactArrayUtil from 'utils/array/compact'
import ProductBadgeDiscountPercentage from 'components/ProductBadges/components/DiscountPercentage'
import ProductBadgeOnlyAtAirshop from 'components/ProductBadges/components/OnlyAtAirshop'
import ProductBadgeJustDropped from 'components/ProductBadges/components/JustDropped'
import ProductBadgeTrending from 'components/ProductBadges/components/Trending'
import ProductBadgeViralOnTikTok from 'components/ProductBadges/components/ViralOnTikTok'
import ProductBadgeMini from 'components/ProductBadges/components/Mini'
import shouldShowJustDroppedAndTrendingBadgeUtil from 'components/ProductCard/utils/should-show-just-dropped-and-trending-badge/index.js'
import ProductBadgeAllFullSize from 'components/ProductBadges/components/AllFullSize'
import ProductBadgeFullSizeAndMinis from 'components/ProductBadges/components/FullSizeAndMinis'
import ProductBadgeMinis from 'components/ProductBadges/components/Minis'
import ProductBadgeTopGift from 'components/ProductBadges/components/TopGift'
import ProductBadgeEquinoxLoves from 'components/ProductBadges/components/EquinoxLoves'
import ProductBadgeAllures2024TopPicks from 'components/ProductBadges/components/Allures2024TopPicks'
import ProductBadgeBlackOwned from 'components/ProductBadges/components/BlackOwned'
import ProductBadgeTopDeal from 'components/ProductBadges/components/TopDeal'
import ProductBadgeSample from 'components/ProductBadges/components/Sample'
import ProductBadgeOnlyFewLeft from 'components/ProductBadges/components/OnlyFewLeft'
import ProductBadgeFullSize from 'components/ProductBadges/components/FullSize'
import ProductBadgeStockingStuffer from 'components/ProductBadges/components/StockingStuffer'
import hasABadgeToShowUtil from 'components/ProductBadges/utils/has-a-badge-to-show/index.js'

/**
 * @param {ProductBadgesProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductBadges (props) {
  const {
    children
  } = props

  const showJustDroppedAndTrending = shouldShowJustDroppedAndTrendingBadgeUtil({
    wasJustDropped: props.wasJustDropped,
    trending: props.isTrending,
    discountPrice: props.discountPercentage,
    isEquinoxLoves: props.isEquinoxLoves,
    isAllures2024TopPicks: props.isAllures2024TopPicks,
    isTopDeal: props.isTopDeal,
    isBlackOwned: props.isBlackOwned
  })

  if (!compactArrayUtil(Object.values(props)).length) {
    return <></>
  }

  if (!hasABadgeToShowUtil(props)) {
    return <></>
  }

  return (
    <Flex className='product-badges'>

      <ProductBadgeDiscountPercentage {...props} />

      <ProductBadgeTopDeal {...props} />

      <ProductBadgeOnlyAtAirshop {...props} />

      <ProductBadgeAllures2024TopPicks {...props} />

      <ProductBadgeBlackOwned {...props} />

      <ProductBadgeEquinoxLoves {...props} />

      <ProductBadgeJustDropped
        {...props}
        showJustDroppedAndTrending={showJustDroppedAndTrending}
      />

      <ProductBadgeMini {...props} />
      <ProductBadgeSample {...props} />
      <ProductBadgeFullSize {...props} />

      <ProductBadgeTopGift {...props} />
      <ProductBadgeAllFullSize {...props} />
      <ProductBadgeFullSizeAndMinis {...props} />
      <ProductBadgeMinis {...props} />

      <ProductBadgeTrending
        {...props}
        showJustDroppedAndTrending={showJustDroppedAndTrending}
      />

      <ProductBadgeViralOnTikTok {...props} />
      <ProductBadgeStockingStuffer {...props} />
      <ProductBadgeOnlyFewLeft {...props} />

      {children}
    </Flex>
  )
}
